import React, { useEffect } from 'react';
import './AssetCheckIn.scss';
import { assetDetailAction } from 'actions/assetDetails';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'components/Placeholders/Loading';
import { findElementByPrompt } from 'utils/utils';
import { singleUploadActions } from 'actions/singleUpload';
import AssetCheckInContent from 'componentsV2/AssetCheckInContent/AssetCheckInContent';
import HeadingNavBar from 'componentsV2/HeadingNavBar/HeadingNavBar';

const AssetCheckIn: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState('CheckOut');
  const [assetDetails, setAssetDetails] = React.useState<any>(null);
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const loading = useSelector((state: any) => state.loading.isLoading);
  const url = window.location.href;
  const assetId = url.split('/').pop() || ''; // Ensure assetId is always a string
  useEffect(() => {
    document.title = 'Asset Check-In';
  }, []);

  useEffect(() => {
    const fetchAssetDetails = async () => {
      try {
        // Get the asset ID from the URL
        dispatch({ type: 'LOADING SUCCESS', payload: true });  
        if (!assetId) {
          console.error('Asset ID is undefined. Unable to fetch asset details.');
          return;
        }
  
        // Fetch asset details using the asset ID
        const response = await assetDetailAction.getAssetDetails(assetId);
        dispatch({ type: 'LOADING SUCCESS', payload: false });

        setAssetDetails(response);
        dispatch(
          singleUploadActions.updateSingleUploadPayload(
            response
          )
        );
      } catch (error) {
        dispatch({ type: 'LOADING SUCCESS', payload: false });
        console.error('Error fetching asset details:', error);
      }
    };
  
    fetchAssetDetails();
  }, []);

  const nameId = findElementByPrompt(assetDetails, 'Name');
  return (
    <div className="asset-check-in" data-testid="asset-check-in">
      <HeadingNavBar activeTab={activeTab} pageTitle={nameId?.value?.display_value || nameId?.value?.id} name={assetDetails?.name ? ` ${assetDetails.name}` : ''}  assetDetails={assetDetails} />
      {/* Render content based on active tab */}
      {activeTab.includes("CheckOut") && (
        <AssetCheckInContent assetDetails={assetDetails} assetId={assetId || ''} />
      )}
      {loading && <Loading/>}
    </div>
  );
};

export default AssetCheckIn;